var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDarkStar = function SvgDarkStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2550",
    d: "m12.405 1.144 1.84 3.23a1 1 0 0 0 .66.5l3.54.81a2.46 2.46 0 0 1 1.25 4l-2.4 2.8a1.08 1.08 0 0 0-.25.81c.22 1.05.547 2.464.463 3.706-.03.445-.114.868-.273 1.244a2.37 2.37 0 0 1-3.12 1.25l-3.32-1.5a1 1 0 0 0-.82 0l-3.32 1.5a2.37 2.37 0 0 1-3.25-2.47l.35-3.73a1.08 1.08 0 0 0-.25-.81l-2.4-2.8a2.46 2.46 0 0 1 1.25-4l3.54-.81a1 1 0 0 0 .66-.5l1.85-3.23a2.32 2.32 0 0 1 4 0"
  })));
};
export default SvgDarkStar;